import React from 'react'
import Contactusimages from '../../components/contactuscomponents/contactusimages'

export default function Contact() {
  return (
    <>
      <Contactusimages />
    </>
  )
}
